import { Component, OnInit } from '@angular/core';
import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';


// Variables Globales
import { Globals } from '../../services/global/global';
import { ToastCommunicationService } from '../../services/toast/toast-communication.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: [
    './admin.component.scss'
  ],
  animations: [
    trigger('notificationBottom', [
      state('an-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('an-animate',
        style({
          overflow: 'hidden',
          height: AUTO_STYLE,
        })
      ),
      transition('an-off <=> an-animate', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger('slideInOut', [
      state('in', style({
        width: '300px',
        // transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        width: '0',
        // transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('mobileHeaderNavRight', [
      state('nav-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('nav-on',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('nav-off <=> nav-on', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger('fadeInOutTranslate', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('400ms ease-in-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translate(0)' }),
        animate('400ms ease-in-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class AdminComponent implements OnInit {

  public sub: any;
  public posicion = 'bottom-right';

  constructor(
    public globals: Globals,
    private router: ActivatedRoute,
    private toastCommunicationService: ToastCommunicationService
  ) {
    this.globals.navType = 'st2';
    this.globals.themeLayout = 'vertical';
    this.globals.verticalPlacement = 'left';
    this.globals.verticalLayout = 'wide';
    this.globals.pcodedDeviceType = 'desktop';
    this.globals.verticalNavType = 'expanded';
    this.globals.verticalEffect = 'shrink';
    this.globals.vnavigationView = 'view1';
    this.globals.freamType = 'theme1';
    this.globals.sidebarImg = 'false';
    this.globals.sidebarImgType = 'img1';
    // this.globals.layoutType = 'dark';
    this.globals.layoutType = 'light';

    this.globals.headerTheme = 'theme1';
    // this.globals.headerTheme = 'themelight5';
    this.globals.pcodedHeaderPosition = 'fixed';

    this.globals.liveNotification = 'an-off';
    this.globals.profileNotification = 'an-off';

    this.globals.chatSlideInOut = 'out';
    this.globals.innerChatSlideInOut = 'out';

    this.globals.searchWidth = 0;

    this.globals.navRight = 'nav-on';

    this.globals.windowWidth = window.innerWidth;

    this.setHeaderAttributes(this.globals.windowWidth);

    this.globals.toggleOn = true;
    // this.globals.navBarTheme = 'theme1';
    this.globals.navBarTheme = 'themelight1';
    this.globals.activeItemTheme = 'theme10';
    this.globals.pcodedSidebarPosition = 'fixed';
    this.globals.menuTitleTheme = 'theme1';
    this.globals.dropDownIcon = 'style3';
    this.globals.subItemIcon = 'style7';

    this.globals.displayBoxLayout = 'd-none';
    this.globals.isVerticalLayoutChecked = false;
    this.globals.isSidebarChecked = true;
    this.globals.isHeaderChecked = true;
    this.globals.headerFixedMargin = '56px';
    this.globals.sidebarFixedHeight = 'calc(100vh - 56px)';
    this.globals.itemBorderStyle = 'none';
    this.globals.subItemBorder = true;
    this.globals.itemBorder = true;

    this.setMenuAttributes(this.globals.windowWidth);
    this.setHeaderAttributes(this.globals.windowWidth);

    this.toastCommunicationService.position$.subscribe(pos => this.posicion = pos);
  }

  ngOnInit(): any {
    /*document.querySelector('body').classList.remove('dark');*/
  }

  onResize(event) {
    this.globals.windowWidth = event.target.innerWidth;
    this.setHeaderAttributes(this.globals.windowWidth);

    let reSizeFlag = true;
    if (this.globals.pcodedDeviceType === 'tablet' && this.globals.windowWidth >= 768 && this.globals.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.globals.pcodedDeviceType === 'mobile' && this.globals.windowWidth < 768) {
      reSizeFlag = false;
    }
    /* for check device */
    if (reSizeFlag) {
      this.setMenuAttributes(this.globals.windowWidth);
    }
  }

  setHeaderAttributes(windowWidth) {
    if (windowWidth < 992) {
      this.globals.navRight = 'nav-off';
    } else {
      this.globals.navRight = 'nav-on';
    }
  }

  setMenuAttributes(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.globals.pcodedDeviceType = 'tablet';
      this.globals.verticalNavType = 'offcanvas';
      this.globals.verticalEffect = 'overlay';
    } else if (windowWidth < 768) {
      this.globals.pcodedDeviceType = 'mobile';
      this.globals.verticalNavType = 'offcanvas';
      this.globals.verticalEffect = 'overlay';
    } else {
      this.globals.pcodedDeviceType = 'desktop';
      this.globals.verticalNavType = 'expanded';
      this.globals.verticalEffect = 'shrink';
    }
  }

  toggleRightbar() {
    this.globals.configOpenRightBar = this.globals.configOpenRightBar === 'open' ? '' : 'open';
  }

  setNavBarTheme(theme: string) {
    if (theme === 'themelight1') {
      this.globals.navBarTheme = 'themelight1';
      this.globals.menuTitleTheme = 'theme1';
      this.globals.sidebarImg = 'false';
    } else {
      this.globals.menuTitleTheme = 'theme6';
      this.globals.navBarTheme = 'theme1';
      this.globals.sidebarImg = 'false';
    }
  }

  setLayoutType(type: string) {
    this.globals.layoutType = type;
    if (type === 'dark') {
      this.globals.headerTheme = 'theme3';
      this.globals.sidebarImg = 'false';
      this.globals.navBarTheme = 'theme1';
      this.globals.menuTitleTheme = 'theme6';
      document.querySelector('body').classList.add('dark');
    } else if (type === 'light') {
      this.globals.sidebarImg = 'false';
      this.globals.headerTheme = 'themelight5';
      this.globals.navBarTheme = 'themelight1';
      this.globals.menuTitleTheme = 'theme1';
      document.querySelector('body').classList.remove('dark');
    } else if (type === 'img') {
      this.globals.sidebarImg = 'true';
      this.globals.headerTheme = 'theme3';
      this.globals.navBarTheme = 'theme1';
      this.globals.menuTitleTheme = 'theme6';
      document.querySelector('body').classList.remove('dark');
    }
  }

}
